export default {
    storeName: 'seating_map_workflow',
    path: 'viewBox',
    normalizeFromStorage: (state, toLoad) => ({
        ...toLoad,
        currentTool: state.currentTool,
        currentTransformation: state.currentTransformation,
        mouseDown: state.mouseDown,
        mouseDrag: state.mouseDrag,
        mouseMove: state.mouseMove,
        mouseUp: state.mouseUp,
        clipboard: state.clipboard,
        selection: {
            ...state.selection,
        },
        referenceImage: {
            ...state.referenceImage,
        },
    }),
};
